import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  useGoogleAuthMutation,
  useMicrosoftAuthMutation,
} from "../../../features/auth/authApiSlice";
import { updateUserName } from "../../../store/modules/userData";
import { setCredentials } from "../../../store/slices/authSlice";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";

export function useSocialSignup() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [googleAuth, { isLoading: isGoogleLoading }] = useGoogleAuthMutation();
  const [microsoftAuth, { isLoading: isMicrosoftLoading }] =
    useMicrosoftAuthMutation();
  const [isSocialLoading, setIsSocialLoading] = useState(false);

  const handleOAuthSuccess = (responseData) => {
    const user = responseData?.data?.user;
    const accessToken = responseData?.data?.accessToken;

    if (user && accessToken) {
      dispatch(setCredentials({ token: accessToken, user }));
      dispatch(updateUserName(user));
      SuccessNotify("Authentication Successful!");
      navigate("/user-profile");
    } else {
      FailedNotify("Authentication response missing user details.");
    }
  };

  const handleGoogleSignup = async (googleResponse) => {
    setIsSocialLoading(true);
    try {
      const payload =
        typeof googleResponse === "string"
          ? { credential: googleResponse }
          : googleResponse;

      const response = await googleAuth(payload).unwrap();
      if (response?.success) {
        handleOAuthSuccess(response);
      } else {
        FailedNotify(response?.message || "Google Authentication Failed.");
      }
    } catch (err) {
      console.error("[handleGoogleSignup Error]:", err);
      const msg =
        err?.data?.message || err?.message || "Google Sign-Up failed.";
      FailedNotify(msg);
    } finally {
      setIsSocialLoading(false);
    }
  };

  const handleMicrosoftSignup = async (msResponse) => {
    setIsSocialLoading(true);
    try {
      const payload =
        typeof msResponse === "string"
          ? { accessToken: msResponse }
          : msResponse?.accessToken
            ? { accessToken: msResponse.accessToken }
            : msResponse;

      const response = await microsoftAuth(payload).unwrap();
      if (response?.success) {
        handleOAuthSuccess(response);
      } else {
        FailedNotify(response?.message || "Microsoft Authentication Failed.");
      }
    } catch (err) {
      console.error("[handleMicrosoftSignup Error]:", err);
      const msg =
        err?.data?.message || err?.message || "Microsoft Sign-Up failed.";
      FailedNotify(msg);
    } finally {
      setIsSocialLoading(false);
    }
  };

  return {
    handleGoogleSignup,
    handleMicrosoftSignup,
    isSocialLoading: isSocialLoading || isGoogleLoading || isMicrosoftLoading,
  };
}
